$(document).ready(function() {
    $('.img1-wrapper').click(function() {
        $('.popup-main-wrap').attr('style', 'display: flex');
        $('#img1-slider').attr('style', 'display: block');
        $('#img2-slider').attr('style', 'display: none');
        $('.close-popup').attr('style', 'display: block');

    });
    $('.img2-wrapper').click(function() {
        $('.popup-main-wrap').attr('style', 'display: flex');
        $('#img2-slider').attr('style', 'display: block');
        $('#img1-slider').attr('style', 'display: none');
        $('.close-popup').attr('style', 'display: block');
    });
    $('.close-popup').click(function() {
        $('#img2-slider').attr('style', 'display: none');
        $('#img1-slider').attr('style', 'display: none');
        $(this).attr('style', 'display: none');
        $('.popup-main-wrap').attr('style', 'display: none');
    });

    $('.variant-input').change(function() {
        const params = new URLSearchParams(window.location.search);
        if (params.has('variant')) {
            let variantId = params.get('variant');
            let targetOption = $(`.js-product-inventory-data .js-variant-inventory-data[data-id="${variantId}"]`).attr('data-barcode');
            $('.product-barcode').text(targetOption);
        }
    });
});